module.exports = __webpack_public_path__ + "static/media/313.654f427d.webp";